var map = {
	"./icon-arrow-category-filter.svg": "25ad",
	"./icon-arrow-more-works.svg": "c2d1",
	"./icon-border-radius-transparent.png": "1490",
	"./icon-camera.svg": "8d06",
	"./icon-chanel-text.svg": "e6a3",
	"./icon-countdown.svg": "22f0",
	"./icon-cross.svg": "d72e",
	"./icon-home.dark.svg": "cc6f",
	"./icon-home.light.svg": "e502",
	"./icon-sku-loading.png": "4a8b",
	"./icon-stacking-looks-arrow.svg": "a008",
	"./icon-stacking-looks-button.svg": "2acf",
	"./icon-try-on.black.svg": "19f3",
	"./icon-try-on.dark.svg": "f384",
	"./icon-try-on.light.svg": "7f9a",
	"./icon-try-on.white.svg": "2340"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5ab3";